import {
  MapContainer,
  TileLayer,
  Tooltip,
  Marker,
  Popup,
  Polygon,
} from "react-leaflet";
import React from "react";

const findCenter = ([topleft, rightbottom]) => {
  const lat = (topleft[0] + rightbottom[0]) / 2;
  const lng = (topleft[1] + rightbottom[1]) / 2;
  return [lat, lng];
};

export const Map = ({ city, data: { districts, bounds, zoom = 13 } }) => {
  return (
    <MapContainer
      bounds={bounds || undefined}
      className="tle_map"
      style={{ width: "100%", height: "500px" }}
      center={findCenter(bounds)}
      zoom={zoom}
      scrollWheelZoom={false}
    >
      {Object.entries(districts).map(([key, district]) => (
        <Polygon key={key} positions={district}>
          <Popup className="tle_map_popup" autoClose closeButton={false}>
            <h4 className="tle_map_popup_title">District {key}</h4>
            <a
              className="tle_map_popup_link"
              href={`#candidats-district${key}`}
            >
              Voir les candidats
            </a>
            <a
              className="tle_map_popup_link"
              href={`#resultats-district${key}`}
            >
              Résultats
            </a>
            <a className="tle_map_popup_link" href={`#ouvoter-district${key}`}>
              Où voter?
            </a>
          </Popup>
        </Polygon>
      ))}
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
    </MapContainer>
  );
};
